import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { User, getAbsoluteUrl } from '../services/api';

interface UserViewModalProps {
  user: User;
  onClose: () => void;
}

const UserViewModal: React.FC<UserViewModalProps> = ({ user, onClose }) => {

  const getProviderBadge = (provider: string | null | undefined) => {
    if (!provider) return <span className="text-gray-500">Email</span>;
    
    const colors = {
      FACEBOOK: 'bg-blue-100 text-blue-800',
      GOOGLE: 'bg-green-100 text-green-800',
      APPLE: 'bg-blue-100 text-blue-800'
    };

    return (
      <span className={`mt-1 float-start px-2 py-1 text-xs font-medium rounded-full text-left w-fit ${colors[provider as keyof typeof colors]}`}>
        {provider}
      </span>
    );
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">User Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="flex items-center mb-6">
            <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mr-4">
              {user.avatar ? (
                <img src={getAbsoluteUrl(user.avatar)} alt={user.name} className="w-16 h-16 rounded-full" />
              ) : (
                <span className="text-2xl font-medium text-gray-600">
                  {(user.username ?? 'A').charAt(0).toUpperCase()}
                </span>
              )}
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900">{user.name}</h3>
              <p className="text-gray-500">{user.email}</p>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 text-left">Phone</label>
              <p className="mt-1 text-sm text-gray-900 text-left">{user.phone || 'Not provided'}</p>
            </div>

            <div className='flex flex-wrap flex-col'>
              <label className="block text-sm font-medium text-gray-700 text-left">Login Provider</label>
              {getProviderBadge(user.socialProvider || 'EMAIL')}
            </div>

            <div className='flex flex-wrap flex-col'>
              <label className="block text-sm font-medium text-gray-700 text-left">Status</label>
              <span className={`mt-1 float-start px-2 py-1 text-xs font-medium rounded-full text-left w-fit ${
                user.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
              }`}>
                {user.isActive ? 'Active' : 'Inactive'}
              </span>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 text-left">Created</label>
              <p className="mt-1 text-sm text-gray-900 text-left">
                {new Date(user.createdAt).toLocaleDateString()} at {new Date(user.createdAt).toLocaleTimeString()}
              </p>
            </div>

            {/* <div>
              <label className="block text-sm font-medium text-gray-700 text-left">Last Login</label>
              <p className="mt-1 text-sm text-gray-900 text-left">
                {user.lastLogin 
                  ? `${new Date(user.lastLogin).toLocaleDateString()} at ${new Date(user.lastLogin).toLocaleTimeString()}`
                  : 'Never'
                }
              </p>
            </div> */}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-imola-primary"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserViewModal; 